/**
 * A full-page error message to show when the user attempts to access something
 * that they don't have permission to see.
 */
import {t} from "@lingui/core/macro";

import {HeadingLarge} from "@khanacademy/wonder-blocks-typography";
import {ErrorMessageWrapper} from "@khan/component-error-message";

export default function PermissionDenied() {
    return (
        <ErrorMessageWrapper fillScreen={true}>
            <HeadingLarge style={{textAlign: "center"}}>
                {t`You do not have permission to view this content`}
            </HeadingLarge>
        </ErrorMessageWrapper>
    );
}
